import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import ContentCard from 'components/ContentCard/ContentCard';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import Modal from 'components/Modal/Modal';
import StyledRadio from 'components/StyledRadio/StyledRadio';
import { generateID, radioBtnStatesOneClick } from 'utils/helpers';

import BulbImg from '../../../images/icons/bulb.png';

import styles from './OneClickRetentionModal.css';


function OneClickRetentionModal({ show, close, handleSave }) {
  const [radioVal, setRadioVal] = useState(radioBtnStatesOneClick.keepOneClick);
  const IDS = {
    prefix: 'AK47M70b',
    element: 'OneClickRetentionModal',
    no: 'no',
    yes: 'yes',
  };
  const makeId = generateID(IDS.prefix, IDS.element);

  const handleChange = useCallback((val) => {
    setRadioVal(val.currentTarget.value);
  }, []);

  const onClickSave = useCallback(() => {
    handleSave(radioVal);
    close();
  }, [handleSave, close, radioVal]);

  const renderCardFooter = (
    <div className={styles.footer}>
      <Button colour="transparent" id={makeId(IDS.no)} label={translate('v2profile.button.cancel')} onClick={close} />
      <LoadingButton
        colour="orange"
        customContainerClass={styles.save}
        id={makeId(IDS.yes)}
        isLoading={false}
        onClick={onClickSave}
      >
        {translate('account.button.save')}
      </LoadingButton>
    </div>
  );

  return (
    <Modal className={styles.modalParent} close={close} show={show}>
      <ContentCard
        className={styles.contentCard}
        footer={renderCardFooter}
        footerClass={styles.contentFooter}
        title={translate('account.privacy.areYouSure')}
      >
        <div className={styles.bulbContainer}>
          <img alt="bulb" src={BulbImg} />
          <span>{translate('account.account.payment.modal.click.bulb')}</span>
        </div>
        <FormControl component="fieldset">
          <RadioGroup aria-label="gender" name="gender-group" value={radioVal} onChange={handleChange}>
            <FormControlLabel
              key={radioBtnStatesOneClick.keepOneClick}
              control={<StyledRadio id={`${IDS.element}_radio_1`} />}
              label={translate('account.account.payment.modal.option.1')}
              value={radioBtnStatesOneClick.keepOneClick}
            />
            <FormControlLabel
              key={radioBtnStatesOneClick.saveCard}
              control={<StyledRadio id={`${IDS.element}_radio_2`} />}
              label={translate('account.account.payment.modal.option.2')}
              value={radioBtnStatesOneClick.saveCard}
            />
            <FormControlLabel
              key={radioBtnStatesOneClick.disableOneClick}
              control={<StyledRadio id={`${IDS.element}_radio_3`} />}
              label={translate('account.account.payment.modal.option.3')}
              value={radioBtnStatesOneClick.disableOneClick}
            />
          </RadioGroup>
        </FormControl>
      </ContentCard>
    </Modal>
  );
}

OneClickRetentionModal.propTypes = {
  close: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSave: PropTypes.func,
};

OneClickRetentionModal.defaultProps = { handleSave: () => undefined };

export default observer(OneClickRetentionModal);
